import {Button} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useState} from "react"
import {useNavigate, useParams} from "react-router-dom"

import {
	ColoredTypography,
	ColoredTypographyWithBottomMargin,
	BulletList,
	GridWithPadding,
	DiscountStyledCard,
} from "./styles"

import {paletteColors} from "@indebted/theme"
import {paymentPlanAPI} from "@indebted/api/paymentPlanAPI"
import {NotEligible} from "@indebted/assets"

const UpdatePlanInformation = ({I18n, HasPaymentPlanOffer}) => {
	const {paymentPlanID} = useParams()
	const navigate = useNavigate()
	const [cancelButtonDisabled, setCancelButtonDisabled] = useState(false)

	const onSetupNewPlanClick = () => {
		setCancelButtonDisabled(true)

		paymentPlanAPI
			.cancel(paymentPlanID!)
			.then((result) => {
				if (result.RequiresAffordabilityAssessment) {
					navigate(`/${result.SecureCode}/affordability-assessment/payment-plan/initiate`)
				} else {
					navigate(`/${result.SecureCode}/payment-plan`)
				}
			})
			.catch((error) => {
				setCancelButtonDisabled(false)
				console.error(error)
			})
	}

	return (
		<GridWithPadding container direction="column" alignItems="center" justifyContent="center">
			{HasPaymentPlanOffer && (
				<Grid
					container
					direction="column"
					alignItems="flex-start"
					justifyContent="flex-start"
					style={{marginTop: "0px"}}
				>
					<DiscountStyledCard
						isEligible={HasPaymentPlanOffer}
						variant="outlined"
						style={{display: "flex", padding: "16px", gap: "6px"}}
					>
						<Grid direction="row" style={{minWidth: "unset"}}>
							<NotEligible />
						</Grid>
						<Grid direction="row">
							<ColoredTypography
								color={paletteColors.stratos}
								style={{fontSize: "14px", lineHeight: "20px"}}
							>
								{I18n.ManagePaymentPlan.UpdatePaymentPlanConfirmationPage.DiscountBanner}
							</ColoredTypography>
						</Grid>
					</DiscountStyledCard>
				</Grid>
			)}

			<Grid
				container
				direction="row"
				alignItems="flex-start"
				justifyContent="flex-start"
				style={{marginBottom: "16px", marginTop: "20px", marginLeft: "-4px"}}
			>
				<ColoredTypographyWithBottomMargin
					variant="h5"
					color={paletteColors.stratos}
					style={{fontWeight: 600, fontSize: "18px", lineHeight: "22px", paddingLeft: "0px"}}
				>
					{I18n.ManagePaymentPlan.UpdatePaymentPlanConfirmationPage.Title}
				</ColoredTypographyWithBottomMargin>
			</Grid>
			<Grid
				container
				direction="row"
				alignItems="flex-start"
				justifyContent="flex-start"
				style={{marginBottom: "10px"}}
			>
				<ColoredTypographyWithBottomMargin
					variant="subtitle1"
					color={paletteColors.stratos}
					style={{fontSize: "14px", lineHeight: "20px"}}
				>
					{I18n.ManagePaymentPlan.UpdatePaymentPlanConfirmationPage.SubTitle}
				</ColoredTypographyWithBottomMargin>
				<br />

				<BulletList color={paletteColors.stratos}>
					{I18n.ManagePaymentPlan.UpdatePaymentPlanConfirmationPage.BulletPoints.map((item, idx) => (
						<li key={idx}>{item}</li>
					))}
				</BulletList>
			</Grid>

			<Grid
				container
				direction="row"
				alignItems="center"
				justifyContent="center"
				style={{marginBottom: "34px", width: "100%"}}
			>
				<Button
					style={{
						borderRadius: "4px",
						padding: "6px 16px",
						width: "100%",
						backgroundColor: paletteColors.warningButtonRed,
					}}
					type="button"
					disabled={cancelButtonDisabled}
					onClick={onSetupNewPlanClick}
					variant="contained"
				>
					{I18n.ManagePaymentPlan.UpdatePaymentPlanConfirmationPage.ContinueButtonLabel}
				</Button>
				<Button
					style={{borderRadius: "35px", padding: "6px 30px", marginTop: "10px"}}
					type="button"
					onClick={() => {
						navigate("./")
						navigate(0)
					}}
					variant="text"
				>
					{I18n.ManagePaymentPlan.UpdatePaymentPlanConfirmationPage.BackButtonLabel}
				</Button>
			</Grid>
		</GridWithPadding>
	)
}

export {UpdatePlanInformation}
